import { ReactNode } from "react";

import { MapEditorFilters } from "~/modules/mapEditor/components/MapEditorFilters";
import { MapEditorObservationTypeTreeFragment } from "~/modules/mapEditor/components/MapEditorObservationTypeTree/fragments.generated";
import { MapEditorProtocolTreeFragment } from "~/modules/mapEditor/components/MapEditorProtocolTree/fragments.generated";
import { MapEditorResearchTypeTreeFragment } from "~/modules/mapEditor/components/MapEditorResearchTypeTree/fragments.generated";
import { MapPillPanelLayers } from "~/modules/mapEditor/components/MapPillPanelLayers";
import { MapPillPanelLayersFragment } from "~/modules/mapEditor/components/MapPillPanelLayers/fragments.generated";
import { ProjectMapEditorFilterVars } from "~/modules/project/hooks/useMapFilters";
import { Shared_FilterOptionFragment } from "~/shared/models/FilterOption.fragment.generated";

type ProjectReviewVisitV2LeftPanelProps = {
    projectId: string;
    layerData: MapPillPanelLayersFragment[] | undefined;
    filterOptions: Shared_FilterOptionFragment[];
    researchTypes: MapEditorResearchTypeTreeFragment[] | undefined;
    observationTypes: MapEditorObservationTypeTreeFragment[] | undefined;
    protocolTreeData: MapEditorProtocolTreeFragment | null | undefined;
    filters: ProjectMapEditorFilterVars;
    setFilter: <K extends keyof ProjectMapEditorFilterVars>(key: K, value: ProjectMapEditorFilterVars[K] | undefined) => void;
    givenLeftPanel: ReactNode;
    selectedLayerId?: string;
    onLayerSelect?: (layerId?: string) => void;
};

export function ProjectReviewVisitV2LeftPanel({
    projectId,
    layerData,
    filterOptions,
    researchTypes,
    observationTypes,
    protocolTreeData,
    filters,
    setFilter,
    givenLeftPanel,
    selectedLayerId,
    onLayerSelect,
}: ProjectReviewVisitV2LeftPanelProps) {
    return (
        <>
            {givenLeftPanel}
            {/* @ts-expect-error `selectable` typing */}
            <MapPillPanelLayers
                selectable={onLayerSelect !== undefined}
                canCreateLayer={false}
                projectId={projectId}
                selectedLayerId={selectedLayerId}
                onSelect={onLayerSelect}
                layers={layerData}
            />
            <MapEditorFilters
                filterOptions={filterOptions}
                filters={filters}
                setFilter={setFilter}
                observationTypeTreeData={observationTypes}
                researchTypeData={researchTypes}
                protocolTreeData={protocolTreeData}
            />
        </>
    );
}
